import { createHttpEndpoint } from '../../utils'

import type {
  GetGoodwillGestures,
  GetPastInvoices,
  GetPastTradeInInvoices,
  GetSellerCompensation,
  GetSellerWallet,
} from './invoices.types'

export const getPastInvoices = createHttpEndpoint<GetPastInvoices>({
  method: 'GET',
  operationId: 'getPastInvoices',
  path: '/finance/merchant/bills',
})

export const getPastTradeInInvoices =
  createHttpEndpoint<GetPastTradeInInvoices>({
    method: 'GET',
    operationId: 'getPastInvoices',
    path: '/finance/merchant/trade-in-invoices',
  })

export const getSellerCompensation = createHttpEndpoint<GetSellerCompensation>({
  method: 'GET',
  operationId: 'getPastInvoices',
  path: '/finance/merchant/compensations',
})

export const getGoodwillGestures = createHttpEndpoint<GetGoodwillGestures>({
  method: 'GET',
  operationId: 'getGoodwillGestures',
  path: '/finance/credit-requests/merchant-list',
})

export const getSellerWallet = createHttpEndpoint<GetSellerWallet>({
  method: 'GET',
  operationId: 'getSellerWallet',
  path: '/finance/seller-ledger/live-balances',
})
